export default __webpack_public_path__ + "static/media/sustainable.ec56cc9d.jpg";